import axios from "axios";
import eventStatusModel from "@/core/models/share/status.interface";
import inveteEventModel from "@/core/models/share/inviteEvent.interface";
import { Actions, Mutations, Getters, Module } from "@/store/enums/homeEnums";
import { config } from "@/core/config";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import apiEnums from "@/core/services/apiEnums";
import ApiService from "@/core/services/ApiService";

import AuthService from "@/core/services/Authservice";
const auth = new AuthService();


const homeModules = {
  namespaced: true,
  state() {
    return {
      MyHostingEventNumber: 0,
      MyParticipantEventNumber: 0,
      MyHostingEvents: new Array<inveteEventModel>(),
      MyParticipantEvents: new Array<inveteEventModel>(),
      MyRecordEvents: new Array<inveteEventModel>(),
      EventStatuses: new Array<eventStatusModel>(),
      UserResponseStatuses: new Array<eventStatusModel>(),
      NeedReloadParticipantEventsFlag: false,
      MyHostingTimeRange: {
        data: new Array(
          dayjs().startOf("day").subtract(1, "week").toDate().valueOf(),
          dayjs().startOf("day").toDate().valueOf()
        ),
      },
      MyRecordTimeRange: {
        data: new Array(
          dayjs().startOf("day").subtract(1, "month").toDate().valueOf(),
          dayjs().startOf("day").toDate().valueOf(),
        ),
      },
    };
  },

  mutations: {
    [Mutations.SetMyHostingMeetingNumber](state: any, payload: Number) {
      state.MyHostingEventNumber = payload;
    },

    [Mutations.SetMyParticipantMeetingNumber](state: any, payload: Number) {
      state.MyParticipantEventNumber = payload;
    },

    [Mutations.SetMyHostingMeetings](state: any, payload: any) {
      //console.log("MyHostingEvents", payload);
      state.MyHostingEvents = payload;
      //console.log("Mutations state.MyHostingEvents", state.MyHostingEvents);
    },

    [Mutations.SetMyParticipantMeetings](state: any, payload: any) {
      //console.log("SetMyParticipantMeetings", payload);
      state.MyParticipantEvents = payload;
      //console.log("Mutations state.MyParticipantEvents", state.MyParticipantEvents);
    },

    [Mutations.SetEventStatuses](state: any, payload: Array<eventStatusModel>) {
      state.EventStatuses = payload.filter((x) => x.Visiable);
    },

    [Mutations.SetUserResponseStatuses](
      state: any,
      payload: Array<eventStatusModel>
    ) {
      state.UserResponseStatuses = payload = payload.filter((x) => x.Visiable);
    },

    [Mutations.SetReloadParticipantEventsFlag](state: any, payload: boolean) {
      state.NeedReloadParticipantEventsFlag = payload;
    },
    [Mutations.SetMyRecordMeetings](state: any, payload: any) {
      state.MyRecordEvents = payload;
    },
  },

  actions: {
    async [Actions.HandEventStatuses](context: any) {
      var endPoint = apiEnums.GetEventStatus.Path;


      await axios
        .get(endPoint)
        .then((response) => {
          context.commit(Mutations.SetEventStatuses, response.data);
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: config.apiEndPoints.jma + endPoint,
            path: endPoint,
          });
        });
    },

    async [Actions.HandUserResponseStatuses](context: any) {
      var endPoint = config.apiEndPoints.jma + apiEnums.GetResponseStatus.Path;

      await axios
        .get(endPoint)
        .then((response) => {
          context.commit(Mutations.SetUserResponseStatuses, response.data);
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },

    async [Actions.HandMyHostingEvents](context: any) {
      var endPoint = config.apiEndPoints.jma + apiEnums.GetHosterEvents.Path;
      var memberid = context.rootState.user.MemberId;
      var MyHostingTimeRange = context.state.MyHostingTimeRange;
      const params = {
        sdate: dayjs(MyHostingTimeRange.data[0]).toDate().toISOString(),
        edate: dayjs(MyHostingTimeRange.data[1])
          .add(1, "days")
          .toDate()
          .toISOString(),
      };
      await axios
        .get(
          endPoint.replace(apiEnums.GetHosterEvents.Params.memberid, memberid),
          { params }
        )
        .then((response: any) => {
          context.commit(Mutations.SetMyHostingMeetings, response.data);
          context.commit(
            Mutations.SetMyHostingMeetingNumber,
            response.data.length
          );
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },

    async [Actions.HandMyParticipantEvents](context: any) {
      var endPoint =
        config.apiEndPoints.jma + apiEnums.GetParticipantEvents.Path;
      var memberid = context.rootState.user.MemberId;
      await axios
        .get(
          endPoint.replace(
            apiEnums.GetParticipantEvents.Params.memberid,
            memberid
          )
        )
        .then((response: any) => {
          context.commit(Mutations.SetMyParticipantMeetings, response.data);
          context.commit(
            Mutations.SetMyParticipantMeetingNumber,
            response.data.length
          );
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },

    [Actions.UpdateReloadParticipantEventsFlag](
      context: any,
      payload: boolean
    ) {
      context.commit(Mutations.SetReloadParticipantEventsFlag, payload);
    },

    async [Actions.HandMyRecordEvents](context: any) {
      var endPoint = config.apiEndPoints.jma + apiEnums.GetRecordEvents.Path;
      var memberid = context.rootState.user.MemberId;
      var MyRecordTimeRange = context.state.MyRecordTimeRange;

      const params = {
        sdate: dayjs(MyRecordTimeRange.data[0]).utc().format(),
        edate: dayjs(MyRecordTimeRange.data[1]).add(2, "days").utc().format(),
      };
      //console.log(params);
      await axios
        .get(
          endPoint.replace(apiEnums.GetRecordEvents.Params.memberid, memberid),
          { params }
        )
        .then((response: any) => {
          context.commit(Mutations.SetMyRecordMeetings, response.data);
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },
  },

  getters: {
    [Getters.EventStatuses]: function (state: any) {
      return state.EventStatuses;
    },
    [Getters.UserResponseStatuses]: function (state: any) {
      return state.UserResponseStatuses;
    },
    [Getters.MyHostingEventNumber]: function (state: any) {
      return state.MyHostingEventNumber;
    },
    [Getters.MyParticipantEventNumber]: function (state: any) {
      return state.MyParticipantEventNumber;
    },
    [Getters.MyHostingEvents]: function (state: any) {
      return state.MyHostingEvents;
    },
    [Getters.TheHostingEvent]: (state: any) => (id: string) => {
      return state.MyHostingEvents.find(
        (o: inveteEventModel) => o.EventHeaderId == id
      );
    },
    [Getters.MyParticipantEvents]: function (state: any) {
      return state.MyParticipantEvents;
    },
    [Getters.TheParticipantEvent]: (state: any) => (id: string) => {
      return state.MyParticipantEvents.find(
        (o: inveteEventModel) => o.EventHeaderId == id
      );
    },
    [Getters.NeedReloadParticipantEventsFlag]: function (state: any) {
      return state.NeedReloadParticipantEventsFlag;
    },
    [Getters.MyHostingTimeRange]: function (state: any) {
      return state.MyHostingTimeRange;
    },
    [Getters.MyRecordTimeRange]: function (state: any) {
      return state.MyRecordTimeRange;
    },
    [Getters.MyRecordEvents]: function (state: any) {
      return state.MyRecordEvents;
    },
    [Getters.TheRecordEvent]: (state: any) => (id: string) => {
      return state.MyRecordEvents.find(
        (o: inveteEventModel) => o.EventHeaderId == id
      );
    },
  },
};

export { Module, homeModules };
